import type { SurfaceCopy } from './surfaceTypes'

export const surfaceRu: SurfaceCopy = {
  pages: {
    continueLearning: 'Продолжить обучение',
    keepLearning: 'Учись дальше',
    practice: 'Практика',
    practiceSubtitle: 'Разовые истории и упражнения — текст, который останется в библиотеке, создай в Чтении.',
    settings: 'Настройки',
    settingsSubtitle: 'Аккаунт и предпочтения',
  },
  actions: {
    startReading: 'Начать чтение',
    browseReading: 'Найти что почитать',
    startRefresh: 'Начать повторение',
    addWords: 'Добавить слова',
    startPractice: 'Начать практику',
    cancel: 'Отмена',
    saved: 'Сохранено',
    readyToRefresh: 'Готово к повторению: {count} слов',
    readyToRefreshOne: 'Готово к повторению: 1 слово',
  },
  coach: {
    title: 'Заметка от коуча',
    dismiss: 'Скрыть',
    andWord: 'и',
    confusionCluster:
      'Ты часто путаешь {words}. Короткая проверка поможет их разделить.',
    formGap:
      'Ты встречал «{surface}» {count} раз при чтении. У {lemma} есть формы, которых ты ещё не видел{formsHint}.',
    formGapNoLemma:
      'Ты встречал «{surface}» {count} раз при чтении. У базового слова есть формы, которых ты ещё не видел{formsHint}.',
    synonymMixup:
      '«{word1}» и «{word2}» похожи по смыслу — потренируемся их различать.',
    synonymMixupGeneric:
      'Эти похожие слова стоит разобрать — поможет короткая проверка.',
    neglectedWord:
      '{word} не было в фокусе уже {days} дн. Готов к короткому повторению?',
    neglectedWordGeneric:
      'Это слово не было в фокусе уже {days} дн. Готов к короткому повторению?',
    ctaPractice: 'Создать статью из этих слов',
    ctaOpenWord: 'Открыть слово',
    ctaChallenge: 'Пройти короткую проверку',
  },
  todayPlan: {
    heading: 'Твой день',
    refresh: 'Повторение',
    newWords: 'Новые слова',
    reading: 'Чтение',
    practice: 'AI-практика',
    allCaughtUp: 'На сейчас всё повторено',
  },
  dashboard: {
    loadFailed: 'Не удалось загрузить Today',
    continueLearningEyebrow: 'Продолжить обучение',
    sessionLabelToday: 'Сегодняшняя сессия',
    sessionLabelComplete: 'Сессия на сегодня завершена',
    headlineResume: 'Продолжи с того места, где остановился',
    headlineReadyMore: 'Готов к ещё одному раунду?',
    headlineWordsReady: 'Готово к повторению: {count} слов',
    headlineWordsReadyOne: 'Готово к повторению: 1 слово',
    headlineMinutesSession: 'Сессия ~{minutes} мин',
    detailWaiting: 'Твоя сессия ждёт тебя.',
    detailDailyDone: 'Дневной минимум выполнен — можно свободно исследовать.',
    detailWhatNext: 'Что хочешь сделать дальше?',
    detailAboutMinutes: 'Около {minutes} мин в твоём плане на сегодня.',
    detailCaughtUp: 'Ты в курсе — дальше может быть короткое чтение.',
    guidedSessionMinutes: 'Сессия ~{minutes} мин',
    startFailed: 'Не удалось начать сессию. Попробуй ещё раз.',
    wordsThisMonth: '+{count} слов в этом месяце',
    totalInVocabulary: '{count} всего в словаре',
    wordsRefreshedToday: 'Сегодня повторено: {count} слов',
    wordsRefreshedTodayOne: 'Сегодня повторено: 1 слово',
    keepMomentum: 'Не теряй темп',
    yesterdayMissed: 'Вчера пропустил «{word}» — сегодня {correct} верно',
    vocabHeading: 'Словарь',
    statusNew: 'Новые',
    statusLearning: 'Изучаю',
    statusReview: 'Повтор',
    statusMastered: 'Выучено',
    dueForReview: 'К повторению',
    viewAllWords: 'Все слова',
    streak: 'Серия',
    dayInARow: 'день подряд',
    daysInARow: 'дней подряд',
    studiedToday: '✓ Ты учился сегодня — так держать!',
    keepStreakAlive: 'Позанимайся сегодня, чтобы сохранить серию.',
    startStreak: 'Начни заниматься, чтобы собрать серию.',
    latestWin: 'Недавняя победа',
    catalogExploreHint: '— загляни в базу языка, когда захочешь побродить',
    feedbackCta: 'Идея или баг? Напиши нам',
  },
  achievementTitles: {
    FIRST_SESSION: 'Первые шаги',
    WEEK_STREAK: 'Недельный воин',
    WORDS_50: 'Коллекционер слов',
    WORDS_100: 'Растущий лексикон',
    WORDS_250: 'Строитель словаря',
    WORDS_500: 'Хранилище слов',
    READING_STREAK_5: 'Ритм чтения',
    COMEBACK: 'С возвращением',
    FIRST_MASTERED: 'Первое освоение',
    CHALLENGE_PERFECT: 'Мастер челленджа',
  },
  aiCredits: {
    heading: 'Дневные AI-кредиты',
    short: 'AI сегодня',
    ofLimit: '{used} использовано · лимит {limit}',
    compact: 'Осталось {remaining} из {limit} AI-кредитов на сегодня',
    hint: 'На генерацию статей, практику и вопросы по тексту. Объяснения слов из кэша бесплатны.',
    costPractice: 'История или урок: {cost}',
    costArticle: 'Личная статья: {cost}',
    costComprehension: 'Вопросы по прочитанному: {cost}',
    costComprehensionCheck: 'Отзыв коуча на ответ: {cost}',
    reset: 'Сброс в {time} (UTC). Смена часового пояса не сбрасывает кредиты.',
    exceeded: 'Дневные AI-кредиты закончились. Сброс в полночь UTC.',
    phraseLimitExceeded: 'Дневной лимит объяснений фраз исчерпан. Уже объяснённые фразы работают — попробуй завтра.',
    phraseQuotaCompact: 'Осталось {remaining} из {limit} новых объяснений фраз на сегодня',
  },
  reading: {
    pickedForYou: 'Для тебя',
    tabForYou: 'Для тебя',
    tabLibrary: 'Библиотека',
    noRecommendationTitle: 'Пока нет рекомендации',
    noRecommendationHint: 'Открой библиотеку или сгенерируй статью из своих слов.',
    filterAll: 'Все',
    filterUnread: 'Непрочитанные',
    filterRead: 'Прочитанные',
    generatePersonalizedTitle: 'Статья из твоего словаря',
    generatePersonalizedHint:
      'AI соберёт до {max} единиц из твоего словаря в короткий личный текст.',
    generatePersonalizedPrivate: 'Статью видишь только ты — другим она не показывается.',
    generatePersonalizedWordCount: '{count} из твоего словаря',
    generatePersonalizedWordCountMax: 'До {max} из твоего словаря',
    shuffleWords: 'Перемешать',
    generatePersonalizedNoWords: 'Сохраняй слова при чтении, чтобы открыть личные статьи.',
    generatePersonalizedCta: 'Сгенерировать статью из словаря',
    generatePersonalizedLoading: 'Пишем твою статью…',
    generatePersonalizedFailed: 'Не удалось сгенерировать статью. Попробуй ещё раз.',
    generatePersonalizedFieldLevel: 'Уровень',
    generatePersonalizedFieldDuration: 'Время чтения',
    generatePersonalizedFieldTopics: 'Темы',
    generatePersonalizedTopicsHint:
      'Выбери до 2 тем. Оставь пустым — возьмём из настроек.',
    durationMinutes: '{minutes} мин',
    durationMinutesApprox: '~{minutes} мин',
    articleGeneratedTitle: 'Статья сохранена в Библиотеку',
    articleGeneratedBody: 'Личная статья готова. Её всегда можно найти во вкладке «Библиотека».',
    articleGeneratedStart: 'Начать чтение',
    articleGeneratedLibrary: 'В библиотеку',
    levelBadge: 'Уровень {level}',
    minRead: '{minutes} мин чтения',
  },
  recommendation: {
    whyArticle: 'Почему эта статья?',
    dueWords: 'Слова к повторению',
  },
  learn: {
    stepOf: 'Шаг {current} из {total}',
    readPrefix: 'Читай:',
    readThenFinish: 'Прочитай статью и отметь «Finished reading», чтобы продолжить сессию.',
    nothingScheduled: 'На сегодня ничего не запланировано',
    startRefresh: 'Начать повторение',
    startChallenge: 'Начать проверку',
    backToToday: 'К «Сегодня»',
  },
  practice: {
    generateStory: 'Создать историю',
    generateLesson: 'Создать урок',
    newLesson: 'Новый урок',
    storyDesc: 'Короткая история на словах из твоего словаря',
    lessonDesc: 'Интерактивный урок: разминка, практика и проверка',
    selectToStart: 'Выбери слова, чтобы начать.',
    wordLimit: '{selected} / {max}',
    wordLimitHint: 'До {max} единиц на историю или урок (зависит от уровня)',
    wordLimitReached: 'Максимум {max} — сними одно, чтобы добавить другое',
    pickRandom: 'Взять {count} случайных',
    pickWords: 'Выбери слова для практики',
    deselectAll: 'Снять выбор',
    articleTipTitle: 'Нужен текст, который останется?',
    articleTipBody:
      'Создай персональную статью в Чтении — она сохранится в библиотеке, и можно тапать слова прямо в тексте.',
    articleTipCta: 'Перейти в Чтение',
  },
  settingsChrome: {
    tabPreferences: 'Предпочтения',
    tabAppearance: 'Оформление',
    tabGoals: 'Цели дня',
    tabNotifications: 'Уведомления',
    tabFeedback: 'Обратная связь',
    tabSecurity: 'Безопасность',
    tabAccount: 'Аккаунт',
    preferencesTitle: 'Предпочтения',
    preferencesDescription: 'Язык, уровень и настройки обучения.',
    savePreferences: 'Сохранить',
    goalsTitle: 'Ежедневные цели',
    goalsDescription: 'Задай цели слайдерами или точными числами.',
    goalsNewWords: 'Новых слов в день',
    goalsReviews: 'Повторений в день',
    goalsArticles: 'Статей в день',
    goalsPractice: 'AI-практик в день',
    goalsPracticeProHint:
      'AI-практика входит в Pro. Цель сохранится и заработает после апгрейда.',
    goalsPracticeOff: 'Выкл',
    saveGoals: 'Сохранить цели',
    notificationsTitle: 'Уведомления',
    notificationsDescription: 'Email и напоминания.',
    notificationsComingSoon: 'Скоро',
    notificationsComingSoonHint:
      'Еженедельный дайджест в разработке. Включим переключатель, когда будет готова доставка.',
    preferredTopics: 'Темы, которые тебе нравятся',
    preferredTopicsHint: 'Используем для рекомендаций статей',
    includeQuickChallenge: 'Короткая проверка в ежедневной сессии',
    includeQuickChallengeHint: 'Добавляет короткий словарный чек в guided-сессию',
    defaultReviewMode: 'Режим повторения по умолчанию',
    defaultReviewModeHint: 'Используется при отдельной сессии повторения',
    targetLevel: 'Целевой уровень английского',
    targetLevelHint: 'Статьи и практика подстроятся под этот уровень.',
    sessionLength: 'Длина guided-сессии',
    sessionLengthLabel: 'Длина guided-сессии: {minutes} мин',
    timezone: 'Часовой пояс',
    timezoneHint: 'Задан при регистрации. Дневные лимиты AI сбрасываются в полночь UTC.',
    securitySignOutTitle: 'Выйти',
    securitySignOutHint: 'Выйти из Lexio на этом устройстве.',
    changePasswordTitle: 'Сменить пароль',
    changePasswordDescription: 'Обнови пароль для входа.',
    accountTitle: 'Аккаунт',
    accountDescription: 'Управление данными аккаунта.',
    backToSettings: 'К настройкам',
    goBack: 'Назад',
    loadFailed: 'Не удалось загрузить настройки',
  },
}
